module.exports = __webpack_public_path__ + "img/team.00b43f7a.png";